import { render, staticRenderFns } from "./veStuGraduationJyzbhRule.vue?vue&type=template&id=678ae72a&scoped=true"
import script from "./veStuGraduationJyzbhRule.vue?vue&type=script&lang=js"
export * from "./veStuGraduationJyzbhRule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "678ae72a",
  null
  
)

export default component.exports